import { render, staticRenderFns } from "./VerticalSeparator.vue?vue&type=template&id=4ebe198f&scoped=true&"
import script from "./VerticalSeparator.vue?vue&type=script&lang=js&"
export * from "./VerticalSeparator.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSeparator.vue?vue&type=style&index=0&id=4ebe198f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe198f",
  null
  
)

export default component.exports